import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Multiselect from "multiselect-react-dropdown";
import { Link, useLocation, useNavigate } from "react-router-dom";
import consultationForm from "../assets/images/consultation-form.png";
import { validateConsulttForm } from "../utils/validation/questionar-validation";
import consultService from "../services/consult-services";
import { toast } from "react-toastify";
const categories = [
  "Security & Surveillance",
  "Plumbing & Water Systems",
  "Electrical & Wiring",
  "Pest Control",
  "AC & HVAC Services",
  "Cleaning & Housekeeping",
  "Gardening & Landscaping",
  "Building Maintenance",
  "Other",
];
const Questionnaire = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const guideType = queryParams.get("guide");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [otherCategory, setOtherCategory] = useState("");
  const [multipleVendor, setMultipleVendor] = useState("");

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    UserName: "",
    ContactNumber: "",
    EmailAddress: "",
    Categories: "",
    Urgency: "",
    Budget: "",
    LookingFor: "",
    OnSiteVisit: "",
    CompareVendor: "",
    ContactMedium: "",
    RequirementDetail: "",
    AddlComments: "",
    ReferenceDoc: null,
  });
  const handleCategoryChange = (selectedList) => {
    setSelectedCategories(selectedList);
    setFormData((prevData) => ({
      ...prevData,
      Categories: selectedList.map((cat) => cat.name),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateConsulttForm(formData);
    setErrors(validationErrors);
    console.log(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const payload = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key === "Categories") {
          formData[key].forEach((category) =>
            payload.append(key, category.name)
          );
        } else {
          payload.append(key, formData[key]);
        }
      });

      try {
        await consultService.submitConsultForm(payload);
        toast.success(
          "Consultation request placed successfully. Our Team will get back to you soon."
        );
        navigate("/thank-you");
      } catch (error) {
        console.error("Error submitting form", error);
        toast.error("Failed to submit form. Please try again.");
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      ReferenceDoc: e.target.files[0],
    }));
  };

  return (
    <>
      <section className="inner-full-banner">
        <div className="banner-img-wrap">
          <img src={consultationForm} alt="" />
        </div>
      </section>
      <section className="grediant-section-bg  section-padding">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="question-card">
                {/* <Row>
                  <Col lg={12}>
                    <div className="bread-crumb">
                      <ul>
                        <li>
                          <Link>Consult</Link>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row> */}
                <Row>
                  <Col lg={12}>
                    <div className="section-title">
                      <h2>
                        Request a free consultation -{" "}
                        {guideType ? guideType : "Consultation"}
                      </h2>
                      <p>
                        Looking for professional home services? Get a free
                        consultation today! Our experts are here to help with a
                        wide range of home solutions, including cleaning,
                        repairs, renovations, pest control, and more. Whether
                        you need assistance with a small fix or a full-scale
                        project, we provide expert guidance to ensure the best
                        results for your home.
                      </p>
                    </div>
                  </Col>
                </Row>
                <div className="row">
                  <div className="col-12 col-md-12">
                    <div className="questions-card">
                      <Form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-lg-6">
                            <Form.Group className="form-group">
                              <Form.Label>
                                User Name<span className="imp-star">*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Your  Name*"
                                name="UserName"
                                value={formData.UserName}
                                onChange={handleInputChange}
                                isInvalid={!!errors.UserName}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.UserName}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="form-group">
                              <Form.Label>
                                Contact Number
                                <span className="imp-star">*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Your  Contact Number*"
                                name="ContactNumber"
                                value={formData.ContactNumber}
                                onChange={handleInputChange}
                                isInvalid={!!errors.ContactNumber}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.ContactNumber}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="form-group">
                              <Form.Label>
                                Email Address
                                <span className="imp-star">*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Your  Email Address*"
                                name="EmailAddress"
                                value={formData.EmailAddress}
                                onChange={handleInputChange}
                                isInvalid={!!errors.EmailAddress}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.EmailAddress}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="mb-4">
                              <Form.Label>
                                Which categories of service do you need
                                assistance with ?
                                <span className="imp-star">*</span>
                              </Form.Label>
                              <Multiselect
                                isVisible={true}
                                options={categories.map((category) => ({
                                  name: category,
                                  id: category,
                                }))}
                                displayValue="name"
                                selectedValues={selectedCategories}
                                onSelect={handleCategoryChange}
                                onRemove={handleCategoryChange}
                                showCheckbox
                                isObject={true}
                                placeholder="Select categories"
                              />

                              {selectedCategories.some(
                                (cat) => cat.name === "Other"
                              ) && (
                                <Form.Control
                                  type="text"
                                  placeholder="Specify other service"
                                  className="mt-2"
                                  value={otherCategory}
                                  onChange={(e) =>
                                    setOtherCategory(e.target.value)
                                  }
                                  required
                                />
                              )}
                              <Form.Control.Feedback type="invalid">
                                {errors.Categories}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="mb-4">
                              <Form.Label>
                                How urgent is your request?
                                <span className="imp-star">*</span>
                              </Form.Label>
                              <Form.Select
                                name="Urgency"
                                value={formData.Urgency}
                                onChange={(e) =>
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    Urgency: e.target.value,
                                  }))
                                }
                                className={errors.Urgency ? "is-invalid" : ""}
                              >
                                <option value="">Select</option>
                                <option value="Immediate">
                                  Immediate (Emergency Service)
                                </option>
                                <option value="Within 24-48 hours">
                                  Within 24-48 hours
                                </option>
                                <option value="Within a week">
                                  Within a week
                                </option>
                                <option value="No Urgency">
                                  No Urgency (Scheduled Consultation)
                                </option>
                              </Form.Select>
                              {errors.Urgency && (
                                <div className="text-danger">
                                  {errors.Urgency}
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-lg-6">
                            <Form.Group className="mb-4">
                              <Form.Label>
                                Do you have a budget range for this service ?
                                <span className="imp-star">*</span>
                              </Form.Label>
                              <Form.Select
                                name="Budget"
                                value={formData.Budget}
                                onChange={handleInputChange}
                              >
                                <option value="">Select</option>
                                <option value="₹5,000 – ₹10,000">
                                  ₹5,000 – ₹10,000
                                </option>
                                <option value="₹10,000 – ₹25,000">
                                  ₹10,000 – ₹25,000
                                </option>
                                <option value="₹25,000+">₹25,000+</option>
                                <option value="No fixed budget, need quotation">
                                  No fixed budget, need quotation
                                </option>
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                {errors.Budget}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="mb-4">
                              <Form.Label>
                                Are you looking for{" "}
                                <span className="imp-star">*</span>
                              </Form.Label>
                              <Form.Select
                                onChange={handleInputChange}
                                className=""
                                name="LookingFor"
                                value={formData.LookingFor}
                              >
                                <option value="">Select</option>
                                <option value="One-time service">
                                  One-time service
                                </option>
                                <option value="Ongoing maintenance contract">
                                  Ongoing maintenance contract
                                </option>
                                <option value="Annual service package">
                                  Annual service package
                                </option>
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                {errors.LookingFor}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </div>

                          <div className="col-lg-6">
                            <Form.Group className="mb-4">
                              <Form.Label>
                                Do you need an on-site visit for assessment?
                                <span className="imp-star">*</span>
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                label="Yes"
                                name="OnSiteVisit"
                                value="Yes"
                                id="onsite-yes"
                                checked={formData.OnSiteVisit === "Yes"}
                                onChange={(e) =>
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    OnSiteVisit: e.target.value,
                                  }))
                                }
                              />
                              <Form.Check
                                type="radio"
                                label="No, a virtual consultation is fine"
                                name="OnSiteVisit"
                                value="No"
                                id="onsite-no"
                                checked={formData.OnSiteVisit === "No"}
                                onChange={(e) =>
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    OnSiteVisit: e.target.value,
                                  }))
                                }
                              />
                              <Form.Check
                                type="radio"
                                label="Not sure, need guidance"
                                name="OnSiteVisit"
                                value="Not sure"
                                id="onsite-not"
                                checked={formData.OnSiteVisit === "Not sure"}
                                onChange={(e) =>
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    OnSiteVisit: e.target.value,
                                  }))
                                }
                              />
                              {errors.OnSiteVisit && (
                                <div className="text-danger">
                                  {errors.OnSiteVisit}
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-lg-6">
                            <Form.Group className="mb-4">
                              <Form.Label>
                                Would you like to compare multiple vendor quotes
                                ?<span className="imp-star">*</span>
                              </Form.Label>
                              <Form.Check
                                type="radio"
                                label="Yes, show me multiple options"
                                name="CompareVendor"
                                value={multipleVendor}
                                id="multiple-vendor-yes"
                                onChange={() =>
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    CompareVendor: "Yes",
                                  }))
                                }
                              />
                              <Form.Check
                                type="radio"
                                label="No, I want a pre-screened vendor"
                                name="CompareVendor"
                                value={multipleVendor}
                                id="multiple-vendor-no"
                                onChange={() =>
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    CompareVendor: "No",
                                  }))
                                }
                              />
                            </Form.Group>
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="mb-4">
                              <Form.Label>
                                Do you have any reference images/documents
                                related to the issue ?
                                <span className="imp-star">*</span>
                              </Form.Label>
                              <Form.Control
                                type="file"
                                className=""
                                onChange={handleFileChange}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="mb-4">
                              <Form.Label>
                                How would you like us to contact you?
                                <span className="imp-star">*</span>
                              </Form.Label>
                              <Form.Select
                                value={formData.ContactMedium}
                                onChange={(e) =>
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    ContactMedium: e.target.value,
                                    ContactDetails: "",
                                  }))
                                }
                              >
                                <option value="">Select</option>
                                <option value="Email">Email</option>
                                <option value="SMS / Whatsapp">
                                  SMS / Whatsapp
                                </option>
                                <option value="Call">Call</option>
                              </Form.Select>
                              {errors.ContactMedium && (
                                <div className="text-danger">
                                  {errors.ContactMedium}
                                </div>
                              )}
                            </Form.Group>

                            {formData.ContactMedium && (
                              <Form.Group className="mb-4">
                                <Form.Control
                                  type="text"
                                  placeholder={`Enter your ${formData.ContactMedium} details`}
                                  value={formData.ContactDetails || ""}
                                  onChange={(e) =>
                                    setFormData((prevData) => ({
                                      ...prevData,
                                      ContactDetails: e.target.value,
                                    }))
                                  }
                                  required
                                />
                                {errors.ContactDetails && (
                                  <div className="text-danger">
                                    {errors.ContactDetails}
                                  </div>
                                )}
                              </Form.Group>
                            )}
                          </div>

                          <div className="col-lg-12">
                            <Form.Group className="mb-4">
                              <Form.Label>
                                Describe your requirement
                                <span className="imp-star">*</span>
                              </Form.Label>
                              <Form.Control
                                as="textarea"
                                className=""
                                rows={5}
                                name="RequirementDetail"
                                value={formData.RequirementDetail}
                                onChange={(e) =>
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    RequirementDetail: e.target.value,
                                  }))
                                }
                              />
                              {errors.RequirementDetail && (
                                <div className="text-danger">
                                  {errors.RequirementDetail}
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-lg-12">
                            <Form.Group className="mb-4">
                              <Form.Label>Any Additional Comments ?</Form.Label>
                              <Form.Control
                                as="textarea"
                                className=""
                                rows={5}
                                name="AddlComments"
                                value={formData.AddlComments}
                                onChange={(e) =>
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    AddlComments: e.target.value,
                                  }))
                                }
                              />
                            </Form.Group>
                          </div>

                          <div className="col-lg-12">
                            <Form.Group className="mb-4 terms-checkbox">
                              <Form.Check
                                className="mt-3"
                                type="checkbox"
                                id="consentCheckbox"
                                label="I agree that my details may be shared with relevant vendors for consultation."
                                required
                              />
                            </Form.Group>
                          </div>
                        </div>

                        <div className="">
                          <Button type="submit" className="btn orange-btn mt-3">
                            Submit
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Questionnaire;
